module.exports = __webpack_public_path__ + "media/gili/coffee-41e229c4.jpg";